import { Grid, Row, Skeleton } from '@fs/zion-ui'
import React from 'react'
import SkeletonAnimationSyncDecorator from './SkeletonAnimationSyncDecorator'

type Props = {
  variant: 'split' | 'chip'
}

export default function PersonQualityScoreButtonSkeleton({ variant }: Props): JSX.Element {
  if (variant === 'split') {
    return (
      <SkeletonAnimationSyncDecorator>
        <div style={{ width: 200 }}>
          <Grid gutters="pico">
            <Skeleton.Paragraph size="md" data-testid="loading-quality-score-action-button" />
            {/* eslint-disable-next-line test-selectors/button -- NA */}
            <Skeleton.Button minWidth={200} />
          </Grid>
        </div>
      </SkeletonAnimationSyncDecorator>
    )
  }
  return (
    <SkeletonAnimationSyncDecorator>
      <Row gutters="none">
        <div style={{ minWidth: 150 }}>
          {}
          <Skeleton.Paragraph size="sm" data-testid="loading-quality-score-action-chip" />
        </div>
        {}
        <Skeleton.Chip />
      </Row>
    </SkeletonAnimationSyncDecorator>
  )
}
